import { IconName } from '@ui-library/Icon/Icon.type';

export enum InteractionMode {
  AGENT = 'agent',
  ASK = 'ask',
}

export interface IInteractionModeOption {
  value: InteractionMode;
  label: string;
  description: string;
  icon: IconName;
}

export interface IInteractionModeSelectorProps {
  mode: InteractionMode;
  onChange: (mode: InteractionMode) => void;
  disabled?: boolean;
  // Viewers with read-only access can only use Ask mode.
  lockedToAsk?: boolean;
}
